import { render, staticRenderFns } from "./PrivateContractForReportWidget.vue?vue&type=template&id=8b374988&scoped=true&"
import script from "./PrivateContractForReportWidget.vue?vue&type=script&lang=js&"
export * from "./PrivateContractForReportWidget.vue?vue&type=script&lang=js&"
import style0 from "./PrivateContractForReportWidget.vue?vue&type=style&index=0&id=8b374988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b374988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b374988')) {
      api.createRecord('8b374988', component.options)
    } else {
      api.reload('8b374988', component.options)
    }
    module.hot.accept("./PrivateContractForReportWidget.vue?vue&type=template&id=8b374988&scoped=true&", function () {
      api.rerender('8b374988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/PrivateContractForReportWidget.vue"
export default component.exports